import styled from "styled-components";

export const StyledClientsFeedback = styled.section`
  position: relative;
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-top: 32px;
  }
  &:before {
    background-color: ${({theme}) => theme.colors.primary};
    bottom: -140px;
    content: '';
    height: 280px;
    position: absolute;
    width: 100%;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      bottom: -120px;
      height: 240px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      bottom: -100px;
      height: 220px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      height: 200px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.medium}) {
      bottom: -60px;
      height: 160px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      background: linear-gradient(#0052CC, #002966);
      bottom: -110px;
      height: 220px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      bottom: -100px;
      height: 210px;
    }
  }
`;

export const HeadingTitle = styled.h2`
  width: 285px;
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 250px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-left: 80px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-left: 60px;
  }
`;

export const VideoCarousel = styled.div`
  margin-left: auto;
  margin-top: 120px;
  position: relative;
  width: 1520px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-top: 100px;
    width: 1300px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-top: 80px;
    width: 1160px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 960px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin-top: 70px;
    width: 760px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    margin-top: 50px;
    width: calc(100% - 80px);
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-top: 32px;
    width: calc(100% - 60px);
  }
  .react-multi-carousel-list {
    position: static;
  }
  .react-multiple-carousel__arrow {
    border: 1px solid ${({theme}) => theme.colors.secondary};
    background-color: ${({theme}) => theme.colors.basic};
    left: unset;
    right: 32%;
    top: -210px;
    z-index: 9;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      min-height: 40px;
      min-width: 40px;
      top: -200px;
      right: 26%;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      min-height: 34px;
      min-width: 34px;
      top: -160px;
      right: 30%;
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      min-height: 28px;
      min-width: 28px;
      top: -150px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      background-color: transparent;
      border: 1px solid ${({theme}) => theme.colors.basic};
      min-height: 36px;
      min-width: 36px;
      top: 250px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.tab}) {
      min-height: 40px;
      min-width: 40px;
      top: 275px;
    }
    &.react-multiple-carousel__arrow--right {
      right: calc(32% - 70px);
      @media (max-width:${({theme}) => theme.breakpoint.hd}) {
        right: calc(26% - 60px);
      }
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        right: calc(30% - 50px);
      }
    }
    &:before {
      color: ${({theme}) => theme.colors.secondary};
      font-weight: bold;
      @media (max-width:${({theme}) => theme.breakpoint.hd}) {
        font-size: ${({theme}) => theme.fonts.smallSize};
      }
      @media (max-width:${({theme}) => theme.breakpoint.default}) {
        font-size: ${({theme}) => theme.fonts.smallestSize};
      }
      @media (max-width:${({theme}) => theme.breakpoint.tab}) {
        color: ${({theme}) => theme.colors.basic};
        font-size: ${({theme}) => theme.fonts.smallerSize};
        top: 1px;
      }
    }
    &:hover {
      background-color: ${({theme}) => theme.colors.secondary};
      @media (max-width:${({theme}) => theme.breakpoint.tab}) {
        background-color: ${({theme}) => theme.colors.basic};
      }
      &:before {
        color: ${({theme}) => theme.colors.basic};
        @media (max-width:${({theme}) => theme.breakpoint.tab}) {
          color: ${({theme}) => theme.colors.secondary};
        }
      }
    }
  }
`;

export const CarouselThumnail = styled.div`
  background-color: ${({theme}) => theme.colors.basic};
  border-radius: ${({theme}) => theme.radius.medium};
  box-shadow: 0 4px 20px #00000033;
  margin-right: 36px;
  overflow: hidden;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    margin-right: 30px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    border-radius: ${({theme}) => theme.radius.hdMedium};
    box-shadow: 0 2px 12px #00000033;
    margin-right: 28px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    margin-right: 24px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    border-radius: ${({theme}) => theme.radius.round};
    margin-right: 20px;
  }
`;

export const VideoSection = styled.div`
  height: 256px;
  overflow: hidden;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    height: 220px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    height: 200px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    border: 1px solid ${({theme}) => theme.colors.light};
    overflow: hidden;
    align-items: center;
    display: flex;
    height: 180px;
    & .video-react.video-react-fluid, 
    & .video-react.video-react-16-9, 
    & .video-react.video-react-4-3 {
      height: 180px;
    }
  }
  @media (max-width:${({theme}) => theme.breakpoint.medium}) {
    height: 160px;
    & .video-react.video-react-fluid, 
    & .video-react.video-react-16-9, 
    & .video-react.video-react-4-3 {
      height: 160px;
    }
  }
  @media (max-width:${({theme}) => theme.breakpoint.tab}) {
    height: 140px;
    & .video-react.video-react-fluid, 
    & .video-react.video-react-16-9, 
    & .video-react.video-react-4-3 {
      height: 140px;
    }
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    height: 180px;
    & .video-react.video-react-fluid, 
    & .video-react.video-react-16-9, 
    & .video-react.video-react-4-3 {
      height: 180px;
    }
  }
  .video-react .video-react-poster {
    background-color: ${({theme}) => theme.colors.basic};
  }
  .video-react .video-react-big-play-button {
    background-color: ${({theme}) => theme.colors.secondary};
    border-radius: 50%;
    border: none;
    box-shadow: 0 0 10px 1px ${({theme}) => theme.colors.default};
    font-size: 5em;
    height: 110px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -40px);
    transition: all .2s ease-in-out;
    width: 110px;
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: 4.5em;
      height: 96px;
      width: 96px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      box-shadow: 0 0 8px 0 ${({theme}) => theme.colors.default};
      font-size: 4em;
      height: 85px;
      top: 60%;
      width: 85px;
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      height: 72px;
      top: 62%;
      width: 72px;
    }
    &:before {
      top: 20px;
      @media (max-width:${({theme}) => theme.breakpoint.hd}) {
        top: 16px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.large}) {
        top: 12px;
      }
      @media (max-width:${({theme}) => theme.breakpoint.default}) {
        top: 8px;
      }
    }
    &:hover {
      box-shadow: none;
    }
  }
`;

export const DetailsSection = styled.div`
  align-items: center;
  display: flex;
  padding: 16px 32px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    padding: 12px 28px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    padding: 10px 24px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    padding: 8px 20px;
  }
`;

export const ClientLogo = styled.div`
  border-radius: 50%;
  border: 1px solid ${({theme}) => theme.colors.default};
  height: 80px;
  margin-right: 16px;
  width: 80px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    height: 70px;
    margin-right: 12px;
    width: 70px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    height: 62px;
    margin-right: 10px;
    width: 62px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    height: 52px;
    width: 52px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    height: 48px;
    width: 48px;
  }
`;

export const Image = styled.img`
  width: 78px;
  @media (max-width:${({theme}) => theme.breakpoint.hd}) {
    width: 68px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    width: 60px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.default}) {
    width: 50px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    width: 46px;
  }
`;

export const ClientLabel = styled.div``;

export const Title = styled.h5`
  color: ${({theme}) => theme.colors.secondary};
  margin-bottom: 6px;
  @media (max-width:${({theme}) => theme.breakpoint.large}) {
    margin-bottom: 4px;
  }
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    margin-bottom: 0;
  }
`;

export const Ratings = styled.div`
  color: ${({theme}) => theme.colors.warning};
  @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
    height: 16px;
  }
  svg {
    font-size: ${({theme}) => theme.fonts.subTitle};
    @media (max-width:${({theme}) => theme.breakpoint.hd}) {
      font-size: ${({theme}) => theme.fonts.hdSubTitle};
    }
    @media (max-width:${({theme}) => theme.breakpoint.large}) {
      font-size: ${({theme}) => theme.fonts.secondarySize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.default}) {
      font-size: ${({theme}) => theme.fonts.defaultSize};
    }
    @media (max-width:${({theme}) => theme.breakpoint.mobile}) {
      font-size: ${({theme}) => theme.fonts.smallSize};
    }
  }
`;
